// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/screens/ProductPortfolio/components/PortfolioCard/index.css
// module id = 3156
// module chunks = 0